module.exports = __webpack_public_path__ + "img/no-sport.197896ca.png";